import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [gallerys, setGallerys] = useState([]);


  useEffect(() => {
    setLandingPageData(JsonData);
    const images = [];
    for(let i =1 ; i < 41; i++){
     const image = {
        title: i+'-small.jpg',
        largeImage: `img/portfolio/${i}.jpg`,
        smallImage: `img/portfolio/${i}.jpg`
      }
      images.push(image);
    }
    setGallerys(images)
    console.log('gallerys', gallerys)
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Gallery data={gallerys} />
      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      <Services data={landingPageData.Services} />
      <Team data={landingPageData.Team} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
